import InfoCircle from "@endya-conformite/ui-kit/src/assets/icons/info-circle.svg?react";
import styles from "./NoEntityForMillesime.module.scss";

type NoEntityForMillesimeProps = {
  millesime?: number;
  entityName?: string;
};

export function NoEntityForMillesime({
  millesime,
  entityName = "entité",
}: NoEntityForMillesimeProps) {
  return (
    <div className={styles.container}>
      <InfoCircle className={styles.containerIcon} />
      <p>
        Cette {entityName} n&apos;a pas été enregistrée sur l&apos;année{" "}
        {millesime}
      </p>
    </div>
  );
}
